import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = ({ children }: any) => {
	const location = useLocation();

	const isHeaderAsContent = location.pathname === '/' || location.pathname === '/games';

	useEffect(() => {
		if (isHeaderAsContent) {
			return;
		}

		window.scrollTo(0, 0);
	}, [location]);
	return <>{children}</>;
};
